<div class="relative w-full h-full">
  <div *ngIf="!isLoading" class="w-full h-full">
    <ig-google-map class="ig-event-map" class="w-full h-full" [markers]="eventsAndMarkers.markers" [center]="mapCenter"
      (onclick)="isShowDetails=false;showingEvent=null" (onMarkerClick)="markerClicked($event)">
    </ig-google-map>

    <div *ngIf="eventsAndMarkers.events.length" [class.hidden]="isShowDetails"
      class="absolute bottom-[14.5rem] left-[10%] p-4 text-lg font-black text-gray-700 mobile:hidden"
      style="backdrop-filter:blur(1px)">{{eventsAndMarkers.events.length}} EVENTS IN ALL
    </div>

    <div #eventsRow [class.opacity-0]="isShowDetails" [class.h-0]="isShowDetails" h-scroll
      class="flex gap-8 absolute bottom-0 pb-1 overflow-y-hidden overflow-x-auto w-4/5 left-[10%] mobile:w-[90%] mobile:left-[5%] mobile:bottom-16">
      <div #event *ngFor="let event of eventsAndMarkers.events" [attr.data-id]="event._id"
        class="p-[8px] h-[216px] bg-white rounded-xl min-w-[16rem] max-w-[16rem] shadow-md relative cursor-pointer mobile:min-w-[10rem] mobile:max-w-[10rem]"
        igClickStopPropagation (click)="showDetails(event)"
        [class.outline]="showingEvent&&showingEvent._id===event._id">
        <div *ngIf="!frontendSettings?.customSettings?.isHideEditorChoice && event.isChoice"
          class="w-[calc(100%-16px)] left-2 px-2 py-2 absolute top-2 right-0 z-10 inline-block bg-gradient-to-b from-[#b04aeacf] to-[#773bf29e] text-xs text-white text-center rounded-t-xl">
          <span class="text-xs">{{frontendSettings?.customSettings.customEditorChoice.editorChoiceForEvent}}</span>
        </div>
        <div class="relative">
          <ig-image [src]="event.cover?.source" class="w-full" cls="aspect-[2/1] rounded-xl"></ig-image>
          <div class="w-full h-1/2 absolute bottom-0 left-0 rounded-2xl bg-gradient-to-b from-transparent to-black">
          </div>
          <div
            class="text-white text-base font-semibold overflow-hidden max-lines-2 absolute w-full bottom-2 mx-3 leading-[1.2rem]">
            {{event.name}}</div>
        </div>

        <div class="text-gray-500 text-sm mt-1 mobile:text-xs">{{event.timeTwoLines?.date}}</div>
        <div class="text-gray-500 text-sm mobile:text-xs">{{event.eventTimes.length<=1 ? event.timeTwoLines?.time
            : 'Multiple times' }} </div>
            <div class="text-gray-400 text-xs overflow-hidden max-lines-2 -mt-2 mobile:text-xs">
              <mat-icon class="text-lg relative top-1.5">room</mat-icon>{{event.address?.address}}
            </div>
        </div>
      </div>
    </div>

    <div
      class="w-[400px] max-w-full h-full border-l-4 border-solid absolute -right-[400px] -top-2 transition-all overflow-y-auto mobile:!bg-white mobile:top-0"
      [class.!right-0]="isShowDetails" style="backdrop-filter:blur(56px)">
      <ig-event-detail-side-modal *ngIf="showingEvent" [event]="showingEvent"
        (back)="isShowDetails=false;showingEvent=null"></ig-event-detail-side-modal>
    </div>


  </div>

  <div *ngIf="isLoading">
    <div id="skeleton-mask-cards" class="absolute top-0 left-0 w-full h-full bg-[#eef5f9] flex flex-col">
      <img src="https://iti-images.s3.amazonaws.com/imgs/map.png" alt="" class="h-3/5 mx-auto object-cover">
      <div class="px-[3vw] py-[1vw]">
        <ig-loading-block [rows]="1" [columns]="4"></ig-loading-block>
      </div>
    </div>
  </div>